import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Inline,
  IconButton,
  Spinner,
} from '@airbus/components-react/components'
import { DisplayModus } from 'constants/constants'
import ModalConfirm from 'components/Modal/ModalConfim'
import ModalTechlogFuel from './modalTechlogFuel'
import { Lang } from 'context/LangContext'
import URL_APIS from 'utils/api/urlApis'
import useQuery from 'utils/hooks/useQuery'
import useMutation from 'utils/hooks/useMutation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import { faSquarePlus } from '@fortawesome/free-regular-svg-icons'

import tools from 'utils/helpers'
import { FuelDetailInput } from 'types/techlog'

type Props = {
  lang: Lang
  avnumap: string | null
  rmdate?: string | null
  rmdoc?: string | null
  voord?: number | null
  displayMode: DisplayModus
  activeStep: number
  canManageFuel: boolean
  setModalFuelOpened: (a: boolean) => void
  setModalFormFuelDisplayMode: (a: DisplayModus) => void
  setSelectedTechlogFuel: (a?: SelectedFuelDetail) => void
  fuelsDetail: SelectedFuelDetail[]
  onFuelsChange: () => void
}

export type SelectedFuelDetail = FuelDetailInput & {
  checked?: boolean
  open?: boolean
  loading?: boolean
  errorMsg?: string
  done?: boolean
  date?: Date
  resourceType?: string
}

const TechlogFuels = ({
  lang,
  avnumap,
  rmdate,
  rmdoc,
  voord,
  displayMode,
  activeStep,
  canManageFuel,
  setModalFuelOpened,
  setModalFormFuelDisplayMode,
  setSelectedTechlogFuel,
  fuelsDetail,
  onFuelsChange,
}: Props) => {
  const { t } = useTranslation()
  const editing = rmdoc && displayMode === DisplayModus.WRITE

  const [fuelToDelete, setFuelToDelete] = useState<SelectedFuelDetail | null>(null)
  const { mutate: deleteFuel } = useMutation(URL_APIS.URL_CRM_FUEL_DELETE)

  const creating = displayMode === DisplayModus.CREATE

  const handleCreateFlightFuel = () => {
    setSelectedTechlogFuel({
      avnumap: avnumap,
      rmdate: tools.convertDatePformatToArrayOfNumber(rmdate),
      rmdoc: rmdoc,
      voord: voord,
      keord: Math.max(fuelsDetail.map((fd) => fd.keord || 0)) + 1,
      keqte: 0,
    })
    setModalFormFuelDisplayMode(DisplayModus.CREATE)
    setModalFuelOpened(true)
  }

  const handleDeleteFlightFuel = async () => {
    if (!fuelToDelete) return
    setFuelToDelete({ ...fuelToDelete, loading: true, open: false })
    await deleteFuel({
      data: fuelToDelete,
      method: 'DELETE',
    })

    // await setTimeout(() => {
    setFuelToDelete(null)
    onFuelsChange()
    // }, 2000)
  }

  const handleUpdateFuel = (fuel: SelectedFuelDetail) => {
    setSelectedTechlogFuel(fuel)
    setModalFormFuelDisplayMode(DisplayModus.WRITE)
    setModalFuelOpened(true)
  }

  return (
    <>
      <div style={{ display: canManageFuel ? 'visible' : 'none' }}>
        {activeStep !== 2 && (
          <IconButton variant='ghost' size='small' onClick={handleCreateFlightFuel} style={{ marginBottom: '1em' }}>
            <FontAwesomeIcon icon={faSquarePlus} />
          </IconButton>
        )}
      </div>

      {!creating && fuelsDetail && fuelsDetail.length > 0 && (
        <div>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>{t('1P00012')}</TableCell>
                <TableCell>{t('7000199')}</TableCell>
                <TableCell>{t('1MRM069')}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {fuelsDetail.map((fuel, i: number) => (
                <TableRow key={'fuel_' + i} style={{ cursor: 'pointer' }}>
                  <TableCell>{fuel.fuelType}</TableCell>
                  <TableCell>{fuel.keqte}</TableCell>
                  <TableCell>{fuel.kebon}</TableCell>
                  <TableCell>
                    {canManageFuel && activeStep !== 2 && (
                      <Inline spacing='1-x'>
                        <IconButton size='small' variant='ghost' onClick={() => handleUpdateFuel(fuel)}>
                          <FontAwesomeIcon size='xs' icon={faPen} />
                        </IconButton>
                        <IconButton
                          size='small'
                          onClick={() => setFuelToDelete({ ...fuel, open: true })}
                          variant='ghost'
                        >
                          {fuel?.keord === fuelToDelete?.keord && fuelToDelete?.loading ? (
                            <Spinner size='small' />
                          ) : (
                            <FontAwesomeIcon size='xs' icon={faTrash} />
                          )}
                        </IconButton>
                      </Inline>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

      <ModalConfirm
        isOpened={Boolean(fuelToDelete?.open)}
        onCloseModal={() => setFuelToDelete(null)}
        confirmMessage={t('9510089')}
        onSubmit={handleDeleteFlightFuel}
      />
    </>
  )
}

export default TechlogFuels
